module.exports = __webpack_public_path__ + "static/img/jd.52c3f566.png";